
import { Component, Prop, Vue } from "vue-property-decorator";
import { ViewportStoreModule } from "@stores/viewport.store";
import { getModule } from "vuex-module-decorators";
import { Emitter } from "@utils/events";

const ViewportStore = getModule(ViewportStoreModule);

type MaxVisibleItems = {
  [key: string]: number;
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
};

@Component({
  name: "ci-users-profile-slider",
})
export default class extends Vue {
  @Prop({ default: () => [] }) public items!: any;
  @Prop({ default: () => 0.5 }) public cuttingThreshold!: any;
  @Prop({ default: () => ({ xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }) }) public maxVisibleItems!: MaxVisibleItems;

  public sliderItems: Portfolios.TileData[] = [];
  public isMounted: boolean = false;

  public gutter = 16;
  // public maxVisibleItems = 3;
  public index = 0;
  public scrollSteps = 2;

  public scrollTarget = 0;
  public vp: Viewport.VPs | "" = ViewportStore.currentViewport;

  public get navigation(): boolean {
    return this.sliderItems.length > this.maxVisibleItemsPerViewport;
  }

  public get maxVisibleItemsPerViewport(): number {
    return this.maxVisibleItems[this.vp] || 1;
  }

  public get sizes(): Indexable {
    const sliderWidth = this.$el.clientWidth;
    const itemWidth = sliderWidth / (this.maxVisibleItemsPerViewport + this.cuttingThreshold);
    return {
      slider: sliderWidth,
      item: itemWidth,
      rail: this.sliderItems.length * itemWidth,
    };
  }

  public next(): void {
    const { endReached } = this.validateScrollSlider();
    if (!endReached) {
      this.scrollTarget = this.scrollTarget + this.sizes.item * this.maxVisibleItemsPerViewport;
      this.scrollSlider();
    }
  }

  public prev(): void {
    const { startReached } = this.validateScrollSlider();
    if (!startReached) {
      this.scrollTarget = this.scrollTarget - this.sizes.item * this.maxVisibleItemsPerViewport;
      this.scrollSlider();
    }
  }

  public visibilityChanged(isVisible: boolean, entry: HTMLElement, item: ExplicitAny): void {
    if (!item.loaded) item.loaded = isVisible;
  }

  protected mounted(): void {
    this.sliderItems = this.items.map((item: any) => ({ loaded: false, content: item }));
    this.isMounted = true;

    Emitter.on("ci::page::viewport-changed", () => {
      this.vp = "";
      this.vp = ViewportStore.currentViewport;
    });
  }

  private validateScrollSlider(): { endReached: boolean; startReached: boolean; slider: HTMLElement } {
    const slider = this.$refs.slider as HTMLElement;
    const endReached = slider.scrollWidth <= slider.scrollLeft + slider.clientWidth;
    const startReached = slider.scrollLeft === 0;

    if (endReached || startReached) this.scrollTarget = slider.scrollLeft;

    return {
      endReached,
      startReached,
      slider,
    };
  }

  private scrollSlider() {
    const slider = this.$refs.slider as HTMLElement;
    slider.scrollTo({ left: this.scrollTarget, behavior: "smooth" });
  }
}
